var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buscar-navbar"},[_c('BuscadorField',{attrs:{"dataset":_vm.dataset}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }